// La séquence J d'un item posée sur le calendrier réel : J0 aujourd'hui, J1 demain, J3 lundi… avec l'exercice de
// chaque J (src/domain/methode.js). C'est la preuve de la mécanique sur l'écran de connexion (un exemple), et la
// suite réelle d'un item sur l'accueil connecté (ses propres prochains J). Une seule ligne de pas pour les deux.
import { html } from '../../core/html.js';
import { conseilPour } from '../../domain/methode.js';

export var J_DEFAUT = [0, 1, 3, 7, 14, 30, 60];

function decaler(ymd, n) { var d = window.parseDateLocal(ymd); d.setDate(d.getDate() + n); return window.toYYYYMMDD(d); }

// L'écart réel d'un pas, en jours pleins depuis le jour de lecture : la suite d'un vrai item glisse (un J14 tombé
// un jour chargé devient J15), et le pas doit pouvoir dire son écart plutôt que laisser croire à une erreur.
function ecartJours(ymd, td) { return Math.round((window.parseDateLocal(ymd) - window.parseDateLocal(td)) / 86400000); }

// « aujourd'hui », « demain », sinon « lun. 22 sept. » (avec l'année quand elle change).
export function dateRelative(ymd, td) {
    if (ymd === td) return 'aujourd\'hui';
    if (ymd === decaler(td, 1)) return 'demain';
    var x = window.parseDateLocal(ymd), o = { weekday: 'short', day: 'numeric', month: 'short' };
    if (x.getFullYear() !== window.parseDateLocal(td).getFullYear()) o.year = 'numeric';
    return x.toLocaleDateString('fr-FR', o);
}

// Les pas d'un item planifié le jour td, pour une liste de J (l'exemple du visiteur).
export function sequenceDepuis(td, js) {
    return (js || J_DEFAUT).map(function(j) { return { type: 'J' + j, date: decaler(td, j) }; });
}

// Les pas réels d'une séance : ses révisions à venir dans le planning (même item, même renforcement), datées.
export function sequenceDe(seance, taches, td) {
    var pedia = !!(seance.isDouble || String(seance.id).indexOf('_bis') !== -1);
    return taches.filter(function(x) {
        return x !== seance && String(x.itemId) === String(seance.itemId) && !!(x.isDouble || String(x.id).indexOf('_bis') !== -1) === pedia && x.date > td && x.type !== 'Loop';
    }).sort(function(a, b) { return a.date.localeCompare(b.date); }).map(function(x) { return { type: x.type, date: x.date, faite: x.status === 'done' }; });
}

// pas : [{ type, date, faite }] ; opts : { td, compact, label }. Compact : une ligne « J1 demain · J3 lun. 22 · … »
// sans l'exercice ; sinon une grille de pas (pastille J, date, exercice) fermée par un filet.
export function renderSequenceJ(pas, opts) {
    opts = opts || {};
    var td = opts.td || window.todayStr();
    return html`<ol class="seqj${opts.compact ? ' seqj--compacte' : ''}" aria-label="${opts.label || 'Séquence de révision'}">${pas.map(function(p) {
        var c = conseilPour(p.type);
        var ecart = ecartJours(p.date, td);
        return html`<li class="seqj-pas${p.date === td ? ' seqj-pas--auj' : ''}${p.faite ? ' seqj-pas--faite' : ''}"${opts.compact ? html` title="${p.type} : ${ecart} jours après la lecture — ${c.long}"` : ''}>
            <span class="seance-j${p.type === 'J0' ? ' seance-j--j0' : ''}">${p.type}</span>
            <span class="seqj-date num">${dateRelative(p.date, td)}</span>
            ${opts.compact ? '' : html`<span class="seqj-quoi" title="${c.long}">${c.court}</span>`}
        </li>`;
    })}</ol>`;
}
